module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var i18n = require(\'@cdo/netsim/locale\');\n  var NetSimConstants = require(\'./NetSimConstants\');\n  var DataConverters = require(\'./DataConverters\');\n\n  var getEncodingLabel = require(\'./NetSimUtils\').getEncodingLabel;\n\n  var EncodingType = NetSimConstants.EncodingType;\n  var PacketUIColumnType = NetSimConstants.PacketUIColumnType;\n\n  /**\n   * @param {EncodingType} encodingType\n   * @param {string} encodedContent\n   */\n  function logRow(encodingType, encodedContent) {\n    %>\n    <tr class="<%= encodingType %>">\n      <th nowrap class="<%= PacketUIColumnType.ENCODING_LABEL %>"><%= getEncodingLabel(encodingType) %></th>\n      <td class="<%= PacketUIColumnType.MESSAGE %>"><%= encodedContent %></td>\n    </tr>\n    <%\n  }\n%>\n<div class="scroll-area bit-log-scroll-area">\n  <div class="packet">\n    <table>\n      <tbody>\n        <%\n          logRow(EncodingType.ASCII, DataConverters.binaryToAscii(binary, chunkSize));\n\n          logRow(EncodingType.DECIMAL, DataConverters.alignDecimal(DataConverters.binaryToDecimal(binary, chunkSize)));\n\n          logRow(EncodingType.HEXADECIMAL, DataConverters.formatHex(DataConverters.binaryToHex(binary), chunkSize));\n\n          logRow(EncodingType.BINARY, DataConverters.formatBinary(binary, chunkSize));\n\n          logRow(EncodingType.A_AND_B, DataConverters.formatAB(DataConverters.binaryToAB(binary), chunkSize));\n        %>\n      </tbody>\n    </table>\n  </div>\n  <% if (showReadWireButton) { %>\n    <div class="panel-footer bit-log-panel-footer">\n      <div class="right-side-controls">\n        <span class="netsim-button large-button" id="read-wire-button"><%= i18n.readWire() %></span>\n      </div>\n    </div>\n  <% } %>\n</div>\n', __filename = "src/netsim/NetSimBitLogPanel.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var i18n = require("@cdo/netsim/locale");
            var NetSimConstants = require("./NetSimConstants");
            var DataConverters = require("./DataConverters");
            var getEncodingLabel = require("./NetSimUtils").getEncodingLabel;
            var EncodingType = NetSimConstants.EncodingType;
            var PacketUIColumnType = NetSimConstants.PacketUIColumnType;
            function logRow(encodingType, encodedContent) {
                __line = 16;
                __append('\n    <tr class="');
                __line = 17;
                __append(escapeFn(encodingType));
                __append('">\n      <th nowrap class="');
                __line = 18;
                __append(escapeFn(PacketUIColumnType.ENCODING_LABEL));
                __append('">');
                __append(escapeFn(getEncodingLabel(encodingType)));
                __append('</th>\n      <td class="');
                __line = 19;
                __append(escapeFn(PacketUIColumnType.MESSAGE));
                __append('">');
                __append(escapeFn(encodedContent));
                __append("</td>\n    </tr>\n    ");
                __line = 21;
            }
            __line = 23;
            __append('\n<div class="scroll-area bit-log-scroll-area">\n  <div class="packet">\n    <table>\n      <tbody>\n        ');
            __line = 28;
            logRow(EncodingType.ASCII, DataConverters.binaryToAscii(binary, chunkSize));
            logRow(EncodingType.DECIMAL, DataConverters.alignDecimal(DataConverters.binaryToDecimal(binary, chunkSize)));
            logRow(EncodingType.HEXADECIMAL, DataConverters.formatHex(DataConverters.binaryToHex(binary), chunkSize));
            logRow(EncodingType.BINARY, DataConverters.formatBinary(binary, chunkSize));
            logRow(EncodingType.A_AND_B, DataConverters.formatAB(DataConverters.binaryToAB(binary), chunkSize));
            __line = 38;
            __append("\n      </tbody>\n    </table>\n  </div>\n  ");
            __line = 42;
            if (showReadWireButton) {
                __append('\n    <div class="panel-footer bit-log-panel-footer">\n      <div class="right-side-controls">\n        <span class="netsim-button large-button" id="read-wire-button">');
                __line = 45;
                __append(escapeFn(i18n.readWire()));
                __append("</span>\n      </div>\n    </div>\n  ");
                __line = 48;
            }
            __append("\n</div>\n");
            __line = 50;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}